import { render, staticRenderFns } from "./OpeningStock.vue?vue&type=template&id=5e058f8a&scoped=true"
import script from "./OpeningStock.vue?vue&type=script&lang=js"
export * from "./OpeningStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e058f8a",
  null
  
)

export default component.exports